import { AssemblyAiToken } from "@/modules/audio-recording/audio-recording.types";

/**
 * Maps to their V3 streaming types here:
 * - https://www.assemblyai.com/docs/api-reference/streaming-api/streaming-api
 */
export enum AssemblyAiTranscriberPayloadType {
  Begin = "Begin",
  Turn = "Turn",
  Termination = "Termination",
  Unknown = "Unknown",
}

export type WebMediaTranscriberInitialConnectRetryConfig = {
  retries?: number;
  factor?: number;
  minTimeoutMs?: number;
  maxTimeoutMs?: number;
};

export type WebMediaTranscriberOptions = {
  tokenProvider: () => Promise<AssemblyAiToken>;
  stream: MediaStream;
  customVocabulary?: string[];
  initialConnectRetryConfig?: WebMediaTranscriberInitialConnectRetryConfig;
};

export type DesktopRecorderTranscriptTurnWord = {
  text: string;
  startMs: number;
  endMs: number;
  confidence: number;
};

export type DesktopRecorderTranscriptTurn = {
  turnOrder: number;
  transcript: string;
  timestampMs: number;
  isFormatted: boolean;
  isEndOfTurn: boolean;
  endOfTurnConfidence: number;
  participantId?: number | string | null;
  words: DesktopRecorderTranscriptTurnWord[];
  raw?: unknown;
};

export type DesktopRecorderTranscriptPartialTurn = DesktopRecorderTranscriptTurn & {
  isEndOfTurn: false;
};

export type DesktopRecorderTranscriptFinalTurn = DesktopRecorderTranscriptTurn & {
  isEndOfTurn: true;
};
